import { DatalistOption } from "app/state/abstract/base.repository";
import { UserRoles } from "app/state/auth.repository";
import { User } from "app/state/users.repository";

export class UserEditPageDto
{
    user: User | undefined;
    coachesList: Array<DatalistOption> = []; 
    managersList: Array<DatalistOption> = []; 
    menteesList: Array<DatalistOption> = []; 
    roles: Array<UserRoles> = [];
}